module.exports = __webpack_public_path__ + "media/images/payment/mastercard-b04891905f8ea07d3ddcf7c8130e0374.png";